import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PostHogProvider } from 'posthog-js/react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import { QueryClientProvider } from 'react-query';
import queryClient from './queryClient';
import store from './redux/store';
import { env } from "./env";
import { injectStore } from './services/api';

injectStore(store);


const options = {
  api_host: env?.REACT_APP_POSTHOG_HOST,
  autocapture: true,
  capture_pageview: false,
  capture_pageleave: true,
  loaded: (posthog) => {
    if (env?.NODE_ENV === 'development') posthog.debug();
  }
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Example primary color
    },
    secondary: {
      main: '#dc004e', // Example secondary color
    },
    background: {
      default: '#f4f6f8',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrapper component to handle PostHog initialization safely
const AppWithPostHog = () => {
  try {
    // Always wrap with PostHogProvider, but only track when appropriate
    const shouldInitializePostHog = env?.REACT_APP_POSTHOG_KEY &&
      (env?.NODE_ENV === 'production' ||
        env?.REACT_APP_POSTHOG_TRACK_DEV === 'true');

    if (shouldInitializePostHog) {
      return (
        <PostHogProvider apiKey={env?.REACT_APP_POSTHOG_KEY} options={options}>
          <App />
        </PostHogProvider>
      );
    } else {
      // For development without PostHog key or when tracking is disabled
      return <App />;
    }
  } catch (error) {
    console.error('PostHog initialization failed:', error);
    // Fallback to App without PostHog if initialization fails
    return <App />;
  }
};

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AppWithPostHog />
        </QueryClientProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

